import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'

const Footer = () => {
    return (
        <footer id="main-footer" className="text-center p-4">
            <Container>
                <Row className="align-items-center">
                    <Col>
                        <p> &copy; Cami Ouzerdine <span id="year"></span></p>
                    </Col>
                    <Col>
                        <Button variant="outline-secondary" href="https://www.petermanchester.dev" target="_blank" rel="noopener noreferrer">
                            Website by Peter Manchester
                            
                        </Button>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
